import { AccountGroup, CashFlowConfig, CashFlowType, GUID } from '@ndvr/portfolio-api';

import { CashflowStream } from 'views/portfolio/PortfolioPage/tabs/liquidity-planning/EditCashflowDialog';
import { convertFormToCashFlowConfigSaveRequest } from 'views/portfolio/PortfolioPage/utils/FormCashFlowConfigConverter';

/** Client-side ids of drafted withdrawals the backend hasn't seen yet. */
const NEW_DRAFT_PREFIX = 'new:';
export const isNewDraftId = (id: string) => id.startsWith(NEW_DRAFT_PREFIX);

/**
 * Builds the draft withdrawal for a form submission. An edit keeps everything the form doesn't cover
 * (expense type, origin, timestamps); a new withdrawal gets a client-side id until the backend assigns one.
 */
export const withdrawalFromForm = (
    form: CashflowStream,
    globalAccountGUID: string,
    accountGroupGUID: GUID<AccountGroup>,
    existing?: CashFlowConfig,
): CashFlowConfig => {
    const request = convertFormToCashFlowConfigSaveRequest(globalAccountGUID, form);
    return {
        moveOriginOnSubmit: false,
        ...existing,
        ...request,
        cashFlowConfigGUID: existing?.cashFlowConfigGUID ?? `${NEW_DRAFT_PREFIX}${crypto.randomUUID()}`,
        withdrawal: request.cashFlowType === CashFlowType.WITHDRAWAL,
        accountGroupGUID,
        // The request omits accountGUID for "Any Account"; make sure that clears a previously chosen account.
        accountGUID: request.accountGUID,
    };
};
